'use client'

import { Badge } from '../badge'
import { Icon } from '../icon'
import type { PriceChangeBadgeProps } from './price-change-badge.types'

export const PriceChangeBadge = ({
  value,
  size = 'sm',
  className = '',
}: PriceChangeBadgeProps) => {
  const isZero = value === 0
  const isPositive = value > 0

  return (
    <Badge
      color={isZero ? 'neutral' : isPositive ? 'positive' : 'negative'}
      size={size}
      className={`flex gap-xs ${className}`}
    >
      {isZero ? (
        '0%'
      ) : (
        <bdi>
          {isPositive && '+'}
          {Math.floor(value * 100) / 100}%
        </bdi>
      )}
      {!isZero && (
        <Icon
          name={isPositive ? 'TriangleUp' : 'TriangleDown'}
          size='xs'
          className='-mr-xs'
          color={`fill-${isPositive ? 'positive-surface-100' : 'negative-surface-100'}`}
        />
      )}
    </Badge>
  )
}
